import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FilterAlertsButton from './filterAlertsButton';
import { alertsTypeListSelector } from '../../selectors/alertsTypeListSelector';

var FilterAlerts = function FilterAlerts(props) {
  var filters = props.filters,
      isLoading = props.isLoading,
      alertTypesOptions = props.alertTypesOptions;
  return /*#__PURE__*/React.createElement(FilterAlertsButton, {
    isLoading: isLoading,
    alertTypesOptions: alertTypesOptions,
    filters: filters
  });
};

FilterAlerts.propTypes = {
  filters: PropTypes.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return alertsTypeListSelector(state);
};

export default connect(mapStateToProps, null)(FilterAlerts);